import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../redux/hooks';
import { openAuth } from '../../redux/slice/authModalSlice';
import AuthModalManager from './AuthModalManager';
import { getAuthToken, getGuestModeFromStorage } from '../../helper/helper';
import { useAppSelector } from '../../redux/hooks';

const LoginPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isGuestModeRedux = useAppSelector((s) => s.authModal.isGuestMode);
  const isGuestModeStorage = getGuestModeFromStorage();
  const isGuestMode = isGuestModeRedux || isGuestModeStorage;
  useEffect(() => {
    const token = getAuthToken();
    if (token || isGuestMode) {
      navigate('/', { replace: true });
      return;
    }
    dispatch(openAuth('signin'));
  }, [dispatch, navigate, isGuestMode]);

  const token = getAuthToken();
  if (token || isGuestMode) {
    return null;
  }

  return <AuthModalManager />;
};

export default LoginPage;
